import { render, staticRenderFns } from "./access-menu-item.vue?vue&type=template&id=ce7f9d50"
import script from "./access-menu-item.vue?vue&type=script&lang=js"
export * from "./access-menu-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports